<template>

    <div class="h-100">
        <!-- <div class="" v-if="!audienceTypes">
            loading
        </div> -->

        <div
            class="h-100 d-flex flex-column py-2"
            v-if="reservation.billing && audienceTypes"
            :class="{'opacity-50': !checkinAllowed}"
        >

            <div class="d-flex flex-grow-1 flex-column px-3">
                <div class="d-flex justify-content-between border-bottom-medium pb-2">
                    <div class="dark pt-2 fs-large font-weight-600">
                        Check-In
                    </div>

                    <div class="">
                        <button :disabled="disabled" class="btn fs-large bg-lightest dark border-medium py-0 px-2 h-100" @click="decrementCheckin"> - </button>
                        <input
                            :disabled="disabled"
                            type="text"
                            class="text-center fs-large darker bg-lighter border-medium radius-normal px-1 py-1 mx-2"
                            style="width: 2rem;"
                            value="0"
                            v-model="reservation.paxCheckedIn"
                            @blur="checkinBlur"
                            v-numInt
                        />
                        <button :disabled="disabled" class="btn fs-large bg-lightest dark border-medium py-0 px-2 h-100" @click="incrementCheckin"> + </button>
                    </div>
                </div>

                <div class="d-flex justify-content-between mt-2">
                    <div class="dark pt-2 fs-large font-weight-600">
                        No-Show
                    </div>

                    <div class="">
                        <button :disabled="disabled" class="btn fs-large bg-lightest dark border-medium py-0 px-2 h-100" @click="decrementNoShow"> - </button>
                        <input
                            :disabled="disabled"
                            type="text"
                            class="text-center fs-large darker bg-lighter border-medium radius-normal px-1 py-1 mx-2"
                            style="width: 2rem;"
                            value="0"
                            v-model="reservation.paxNoShow"
                            @blur="noShowBlur"
                            v-numInt
                        />
                        <button :disabled="disabled" class="btn fs-large bg-lightest dark border-medium py-0 px-2 h-100" @click="incrementNoShow"> + </button>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center mt-3">
                <span v-if="totalPax == 0" class="bold dark" @click="checkAllIn">No Pax selected</span>
                <button :disabled="disabled" v-else-if="!allChecked" class="btn tertiary" @click="checkAllIn">Check-in All</button>
                <button :disabled="disabled" v-else-if="allChecked" class="btn tertiary" :class="checkinAllButton" @click="checkAllIn">All checked <i class="ico ico-check mr-0 ml-2"></i></button>
            </div>

            <div class="py-2 text-center" v-if="!checkinAllowed">
                <span v-if="isReservationReadOnly">Booking read only</span>
                <span v-else-if="totalDue > 0">Booking not paid</span>
            </div>


        </div>

        <div v-else class="dark text-center m-3">
            <div class="fs-large darker">Loading</div>
        </div>

    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'

import {mapActions, mapGetters} from 'vuex'
import {eventHub} from '@/main'

export default {
    data: function() {
        return {
            editingPax: false,
            showDetailedCheckin: false,
            alertHasBeenShown: false
        }
    },
    props:{
        reservation:{
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.alertHasBeenShown = false;
    },
    asyncComputed: {
        async audienceTypes() {
            try {
                let response = await axios.get('/api/settings/GetAudienceTypeList');

                if (response && response.status === 200 && response.data && response.data.length > 0) {

                    return response.data;
                }
            }
            catch (error) {
                this.$toasted.error(error);
            }
        }
    },
    computed: {
        ...mapGetters([
            'account',
            'getReservationCalculations',
            'getShowInvoiceOption'
        ]),
        allChecked: function() {
            return this.reservation.paxCheckedIn + this.reservation.paxNoShow == this.totalPax
        },
        checkinAllowed: function() {
            return this.totalDue <= 0 && !this.isReservationReadOnly
        },
        checkinAllButton: function () {
            if(!this.reservation.updateFlags.checkins || this.reservation.updateFlags.checkins !== true){
                if(this.reservation.paxNoShow > 0){
                    return 'bg-color-4 lightest'
                } else {
                    return 'bg-color-3 lightest'
                }
            } else {
                return ''
            }
        }
    },
    mixins: [
        reservationsMixin
    ],
    methods: {
        ...mapActions([
            'updateCheckinsNoShows',
            'setReservationCalculations',
        ]),
        incrementCheckin: function() {
            /**
             * checkin alert - shown if it's too early for the event time
             */
            const eventDate = moment(this.reservation.eventDate);
            const todayDate = moment().format();

            const diff = moment.duration(eventDate.diff(todayDate)).humanize()

            if(this.checkinAllowed){
                //** Show the DIALOG if event date is greater than today AND the difference in days is greater than 0 AND the difference in hours is greater than 1 hour (3600000 milliseconds) */
                if(this.alertHasBeenShown == false && this.allChecked == false && moment.duration(eventDate.diff(todayDate)) >= 3600000 ) {
                    this.$dialog.confirm(
                        'Looks like there\'s more than 1 hour until the event start. Do you really want to continue with the check-in?',
                        {okText: 'Yes', cancelText: 'No'}
                    ).then(() => {
                        if(this.reservation.paxCheckedIn < this.totalPax && this.reservation.paxCheckedIn + this.reservation.paxNoShow < this.totalPax){
                            this.reservation.paxCheckedIn++
                            this.checkinNoShowChanged()
                        }
                        this.alertHasBeenShown = true;
                    }).catch((err) => {});
                } else if(this.alertHasBeenShown == false && this.allChecked == false && moment.duration(eventDate.diff(todayDate)) <= 0) {
					// Alert for past events. This is to prevent checkin in past events
					this.$dialog.confirm(
                        'Looks like the event date has passed. Do you really want to continue with the check-in?',
                        {okText: 'Yes', cancelText: 'No'}
                    ).then(() => {
                        if(this.reservation.paxCheckedIn < this.totalPax && this.reservation.paxCheckedIn + this.reservation.paxNoShow < this.totalPax){
                            this.reservation.paxCheckedIn++
                            this.checkinNoShowChanged()
                        }
                        this.alertHasBeenShown = true;
                    })
				}
				else {
                    //** less than 1 hour, No need to show the DIALOG, proceed with the checkin */
                    if(this.reservation.paxCheckedIn < this.totalPax && this.reservation.paxCheckedIn + this.reservation.paxNoShow < this.totalPax){
                        this.reservation.paxCheckedIn++
                        this.checkinNoShowChanged()
                    }
                }
            }
        },
        decrementCheckin: function() {
            if(this.checkinAllowed){
                if(this.reservation.paxCheckedIn > 0){
                    this.reservation.paxCheckedIn--
                    this.checkinNoShowChanged()
                }
            }
        },
        checkinBlur: function () {
            if(this.reservation.paxCheckedIn >= 0 && (this.reservation.paxCheckedIn <= this.totalPax && (parseInt(this.reservation.paxCheckedIn) + parseInt(this.reservation.paxNoShow)) <= this.totalPax)){
                //tweak to make the button "all checked in" update
                this.reservation.paxCheckedIn++
                this.reservation.paxCheckedIn--

                this.checkinNoShowChanged()
            } else {
                this.reservation.paxCheckedIn = 0
                this.$toasted.error('Invalid Check-in amount');
            }
        },
        incrementNoShow: function() {
            if(this.checkinAllowed){
                if(this.reservation.paxNoShow < this.totalPax && this.reservation.paxCheckedIn + this.reservation.paxNoShow < this.totalPax){
                    this.reservation.paxNoShow++
                    this.checkinNoShowChanged()
                }
            }
        },
        decrementNoShow: function() {
            if(this.checkinAllowed){
                if(this.reservation.paxNoShow > 0){
                    this.reservation.paxNoShow--
                    this.checkinNoShowChanged()
                }
            }
        },
        noShowBlur: function () {
            if(this.reservation.paxNoShow >= 0 && (this.reservation.paxNoShow <= this.totalPax && (parseInt(this.reservation.paxCheckedIn) + parseInt(this.reservation.paxNoShow)) <= this.totalPax)){
                //tweak to make the button "all checked in" update
                this.reservation.paxNoShow++
                this.reservation.paxNoShow--

                this.checkinNoShowChanged()
            } else {
                this.reservation.paxNoShow = 0
                this.$toasted.error('Invalid No-Show amount');
            }
        },
        checkAllIn: function() {
            /**
             * checkin alert - shown if it's too early for the event time
             */
            const eventDate = moment(this.reservation.eventDate);
            const todayDate = moment().format();

            const diff = moment.duration(eventDate.diff(todayDate)).humanize()
            // console.log('eventDate, todayDate, diff :>> ', eventDate, todayDate, diff);

            if(this.checkinAllowed){
                //** Show the DIALOG if event date is greater than today AND the difference in days is greater than 0 AND the difference in hours is greater than 1 hour (3600000 milliseconds) */
                if(this.allChecked == false && moment.duration(eventDate.diff(todayDate)) >= 3600000 ) {
                    this.$dialog.confirm(
                        'Looks like there\'s more than 1 hour until the event start. Do you really want to continue with the check-in?',
                        {okText: 'Yes', cancelText: 'No'}
                    ).then(() => {
                        this.reservation.paxCheckedIn = this.totalPax
                        this.reservation.paxNoShow = 0
                        this.checkinNoShowChanged()
                    }).catch((err) => {

                    });
                } else if(this.allChecked == false && moment.duration(eventDate.diff(todayDate)) <= 0) {
					// Alert for past events. This is to prevent checkin in past events
					this.$dialog.confirm(
                        'Looks like the event date has passed. Do you really want to continue with the check-in?',
                        {okText: 'Yes', cancelText: 'No'}
                    ).then(() => {
                        this.reservation.paxCheckedIn = this.totalPax
                        this.reservation.paxNoShow = 0
                        this.checkinNoShowChanged()
                    }).catch((err) => {

                    });
				} else {
                    //** less than 1 hour, No need to show the DIALOG, proceed with the checkin */
                    this.reservation.paxCheckedIn = this.totalPax
                    this.reservation.paxNoShow = 0
                    this.checkinNoShowChanged()
                }
            }
        },
        noShowAllIn: function() {
            if(this.checkinAllowed){
                this.reservation.paxCheckedIn = 0
                // this.reservation.paxNoShow = this.reservation.paxTotal
                this.reservation.paxNoShow = this.totalPax
                this.checkinNoShowChanged()
            }
        },
        checkinNoShowChanged: function() {
            // disable this function, the checkin/no-show data are now saved only on save reservation
            return false
        },
    }
}
</script>

<style lang="scss" scoped>

.paxQtdEditor{
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// Checkins.vue?7a3a2ac0